import { useState, useEffect, useRef } from 'react';
import { Calendar, ChevronDown, Check } from 'lucide-react';

const ViewModeDropdown = ({ value, onChange, accent = '#3b82f6' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleSelect = (mode) => {
    onChange(mode);
    setIsOpen(false);
  };

  const options = [
    { label: 'Monthly', value: 'monthly' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Daily', value: 'daily' }
  ];
  
  const selectedLabel = options.find(o => o.value === value)?.label || 'Weekly';

  return (
    <div style={{ position: 'relative' }} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          border: '1px solid #e2e8f0', borderRadius: '9px',
          padding: '0 12px', height: '34px', fontSize: '13px', color: '#334155',
          background: '#fff', cursor: 'pointer', outline: 'none',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          gap: '8px', minWidth: '110px', fontWeight: '500',
          borderColor: isOpen ? accent : '#e2e8f0',
          boxShadow: isOpen ? `0 0 0 3px ${accent}20` : '0 2px 4px rgba(0,0,0,0.02)',
          transition: 'all 0.2s',
          fontFamily: "'Inter', sans-serif",
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Calendar size={14} color={accent} style={{ flexShrink: 0 }} />
          <span>{selectedLabel}</span>
        </div>
        <ChevronDown size={14} color="#94a3b8" style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', flexShrink: 0 }} />
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute', top: 'calc(100% + 4px)', left: 0,
            zIndex: 350, background: '#fff', borderRadius: '12px',
            border: '1.5px solid #e2e8f0', boxShadow: '0 12px 32px rgba(0,0,0,0.14)',
            overflow: 'hidden', animation: 'dropFadeIn 0.15s ease',
            display: 'flex', flexDirection: 'column',
            width: '100%', minWidth: '120px'
          }}
        >
          <div style={{ padding: '4px' }}>
            {options.map((opt, i) => {
              const isSelected = value === opt.value;
              return (
                <div
                  key={i}
                  onClick={() => handleSelect(opt.value)}
                  style={{
                    padding: '8px 10px', fontSize: '13px', color: '#334155',
                    cursor: 'pointer', borderRadius: '6px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    background: isSelected ? `${accent}15` : 'transparent',
                    fontWeight: isSelected ? '600' : '400',
                  }}
                  onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.background = '#f8fafc'; }}
                  onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.background = 'transparent'; }}
                >
                  <span>{opt.label}</span>
                  {isSelected && <Check size={14} color={accent} style={{ flexShrink: 0 }} />}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewModeDropdown;
